<template>
     <el-dialog
        title="销售策略"
        :visible.sync="visible"
        width="1500px"
        :before-close="handleClose"
        top="5vh"
    >
        <div class="sales-rule-dialog" ref="dialogRef">
            <SalesRuleTeam
                :defaultExpandAll="true"
                :treeHeight="treeHeight"
                ref="salesRuleTeamRef"
                @nodeClick = "handleNodeClick"
                :data="teamData"
            />
            <el-row class="sales-rule-row" :gutter="20">
                <el-col :span="8">
                   <div class="dialog-col" ref="dialogColRef">
                       <div class="dialog-title">团队人员 <span class="sub-title">{{node.name || ''}}</span></div>
                        <SalesMethodtable
                            :tableData="teamTableData"
                            :tableHeight="tableHeight"
                            @rowClick = "handleRowClick"
                            type="team"
                        />
                   </div>
                </el-col>
                <el-col :span="8">
                    <div class="dialog-col">
                        <div class="dialog-title">分配买家</div>
                        <SalesMethodtable
                            :tableData="waitClinicData"
                            :tableHeight="tableHeight"
                            type="waitClinic"
                        />
                   </div>
                </el-col>
                <el-col :span="8">
                    <div class="dialog-col">
                        <div class="dialog-title">已分配买家</div>
                        <SalesMethodtable
                            :tableData="assignedClinicData"
                            :tableHeight="tableHeight"
                            type="assigned"
                        />
                   </div>
                </el-col>
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
import SalesRuleTeam from "./salesRuleTeam.vue"
import SalesMethodtable from "./salesMethodTable.vue"
import { 
    queryOrgStructureByAdplanId,
    ssAdTeamMembers,
    ssAdTeamAreasGetWaitClinic,
    ssAdTeamAreasGetAllocatedClinic
} from "@/api/saleRule/agent"
export default {
    name: 'SalesMethodDialog',
    components: {
        SalesRuleTeam,
        SalesMethodtable
    },
    props: {
       
    },
    data() {
        return {
            visible: false,
            searchText: '',
            tableHeight: 0,
            treeHeight: 0,
            node: {},
            teamData: [],
            teamTableData:[],
            waitClinicData:[],
            assignedClinicData:[],
                    
        }
    },
    methods: {
        publicOpen(e) {
            const { adPlanId } = e
            if(!adPlanId)return
            this.adPlanId = adPlanId
            this.visible = true
            this.requestTreeData();
            this.$nextTick(() => {
                const dialogHeigth = this.$refs.dialogRef.offsetHeight - 32;
                const treeHeigth = this.$refs.dialogRef.offsetHeight - 100;
                this.tableHeight = dialogHeigth;
                this.treeHeight = treeHeigth;
            })
            
        },
        handleClose() {
            this.visible = false
        },
        handleNodeClick(node) {
            this.node = node
            this.requestTeamData(node.id)
            this.clearData()
        },
        requestTreeData() {
            try {
                queryOrgStructureByAdplanId(this.adPlanId).then(res => {
                    if(res && res.children){
                        this.teamData = res.children
                        this.requestTeamData(res.children[0].id)
                        this.$nextTick(() => {
                            this.$refs.salesRuleTeamRef.publicSetCurrentNodeKey(res.children[0].id)
                        })
                            
                    }else{
                        this.teamData = []
                    }
                })
            } catch (error) {
                this.teamData = []
            }
        },
        requestTeamData(teamId) {
            try {
                ssAdTeamMembers({teamId}).then(res => {
                    if(res && res.length){
                        this.teamTableData = res
                    }else{
                        this.teamTableData = []
                    }
                })
                
            } catch (error) {
                this.teamTableData = []
            }
        },
        // 待分配买家数据
        requestWaitClinicData(teamId, teamMemberId) {
            try {
                const obj = {
                    teamId,
                    teamMemberId,
                    name: ''
                }
                ssAdTeamAreasGetWaitClinic(obj).then(res => {
                    if(res && res.length){
                        this.waitClinicData = res
                    }else{
                        this.waitClinicData = []
                    }
                })
            } catch (error) {
                this.waitClinicData = []
            }
        },
        // 已分配买家数据
        requestAssignedClinicData(teamId, teamMemberId) {
            try {
                const obj = {
                    teamId,
                    teamMemberId,
                    name: ''
                }
                ssAdTeamAreasGetAllocatedClinic(obj).then(res => {
                    if(res && res.length){
                        this.assignedClinicData = res
                    }else{
                        this.assignedClinicData = []
                    }
                })
            } catch (error) {
                this.assignedClinicData = []
            }
        },
        handleRowClick(row) {
            const { id, teamId } = row
            if(!id || !teamId)return
            this.requestWaitClinicData( teamId, id )
            this.requestAssignedClinicData( teamId, id )
        },
        // 清空 待分配和已分配买家数据
        clearData() {
            this.waitClinicData = []
            this.assignedClinicData = []
        }

    }
}
</script>


<style scoped lang="scss">

.sales-rule-dialog {
    display: flex;
    height: 80vh;
    .sales-rule-row {
        display: flex;
        flex:1;
        margin-left: 20px;
        .dialog-col {
            height: 100%;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            overflow: hidden;
            .dialog-title {
                color: #f5222d;
                background-color: #FEF3F2;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 32px;
                font-size: 14px;
            }
            .sub-title {
                color: #333;
                margin-left: 20px;
                font-weight: bold
            }
        }
    }
}
</style>